
import React, { useRef, useEffect } from 'react';
import { Navbar } from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';
import { useLanguage } from '@/context/LanguageContext';
import ContactForm from '@/components/homepage/contact/ContactForm';

const ContactMe: React.FC = () => {
  const { t } = useLanguage();
  const pageTopRef = useRef<HTMLDivElement>(null);
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div ref={pageTopRef} className="relative min-h-screen overflow-x-hidden bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900">
        {/* Background elements */}
        <div className="absolute inset-0 bg-black/30 z-0"></div>
        <div className="absolute top-0 right-1/3 w-80 h-80 rounded-full bg-indigo-500/5 blur-3xl"></div>
        <div className="absolute bottom-0 left-1/3 w-64 h-64 rounded-full bg-purple-500/10 blur-3xl"></div>
        
        <div className="relative z-10 container mx-auto px-4 pt-28 pb-16">
          {/* Title and subtitle outside the form frame */}
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-montserrat font-bold text-white mb-2">
              {t('contactMe.page.title')}
            </h1>
          </div>

          <div className="max-w-3xl mx-auto glassmorphism-dark p-8 rounded-xl">
            <p className="text-center text-gray-300 mb-8">
              {t('contactMe.instructions')}
            </p>

            <ContactForm />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactMe;
